// -- External libraries
import { mergeProps } from 'solid-js'

export const useBarAtomComponentController = (props) => {
    const defaultProps = {}
    const mergedProps = mergeProps(defaultProps, props)

    return {
        mergedProps,
    }
}
